export function AsIsVsRemodelHero() {
  return (
    <section className="relative min-h-[75vh] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/61a26aae47fc93e1501c4bc5f087727a.jpg"
          alt="Apartment building AS IS vs remodeled comparison"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-6 py-20 text-center text-white">
        <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
          Sell AS IS vs Remodel: The Complete Guide for Apartment Building Owners
        </h1>
        <p className="text-xl md:text-2xl mb-8 leading-relaxed max-w-4xl mx-auto">
          Should you invest thousands in renovations or sell your apartment complex as-is? Discover which strategy maximizes your profit, saves time, and eliminates stress when selling your multifamily property.
        </p>
      </div>
    </section>
  );
}